<template>
  <div v-if="stock_out && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="stock_out" />
  </div>
</template>
<script>
import DeliverDetail from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    stock_out: {},
  }),

  mounted() {
    PrintTemplates.fetchOne("shipStockOrderOut").then(
      function (response) {
        if (response.data.status.isOK()) {

          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          DeliverDetail.deliverDetailPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stock_out = response.data.stock_out;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>